module.exports = __webpack_public_path__ + "img/logo.a9f95bfc.png";